<template>
  <article class="insight-card">
    <div class="insight-head">
      <div>
        <h3>{{ title }}</h3>
        <p v-if="description" class="insight-description">{{ description }}</p>
      </div>
      <slot name="actions"></slot>
    </div>

    <div v-if="!isEmpty" class="insight-body">
      <slot></slot>
    </div>

    <p v-else class="empty-state">{{ emptyText }}</p>
  </article>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InsightListCard',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'Nenhum dado disponivel.'
    }
  }
})
</script>

<style scoped>
.insight-card {
  padding: 18px;
  border-radius: 16px;
  background: color-mix(in srgb, var(--bg-secondary) 84%, transparent);
  border: 1px solid color-mix(in srgb, var(--border-color) 82%, transparent);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.insight-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.insight-head h3 {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 600;
}

.insight-description {
  margin-top: 4px;
  color: var(--text-secondary);
  font-size: 13px;
}

.insight-body {
  display: grid;
  gap: 10px;
}

.empty-state {
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 700;
}
</style>
